export default "__VITE_ASSET__4a0ee4bf__"